import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { Switch } from '@/components/ui/switch';
import { Sparks } from 'iconoir-react';

interface AiPersonalizeToggleProps {
  checked: boolean;
  onCheckedChange: (details: { checked: boolean }) => void;
  creatorCount: number;
  disabled?: boolean;
}

export const AiPersonalizeToggle = memo(function AiPersonalizeToggle({
  checked,
  onCheckedChange,
  creatorCount,
  disabled,
}: AiPersonalizeToggleProps) {
  const { t } = useTranslation();

  return (
    <Box
      bg="transparent"
      border="1px solid"
      borderColor={checked ? 'purple.200' : 'gray.200'}
      rounded="xl"
      px={4}
      py={3}
    >
      <HStack justify="space-between" align="center">
        <HStack gap={3} align="start">
          <Icon asChild mt={0.5}>
            <Sparks width={18} height={18} />
          </Icon>
          <VStack align="start" gap={0.5}>
            <Text fontSize="sm" fontWeight="medium">
              {t('invitations.modal.aiPersonalize.label')}
            </Text>
            <Text fontSize="xs" color="fg.muted">
              {checked
                ? t('invitations.modal.aiPersonalize.helperActive', { count: creatorCount })
                : t('invitations.modal.aiPersonalize.helper')}
            </Text>
          </VStack>
        </HStack>
        <Switch
          size="sm"
          colorPalette="purple"
          checked={checked}
          onCheckedChange={onCheckedChange}
          disabled={disabled}
          aria-label={t('invitations.modal.aiPersonalize.label')}
        />
      </HStack>
    </Box>
  );
});
